<template>
    <div class="component-centered-Lot">
        <h1>
            Gestion des feuilles de soins
            <span v-if="resGetFSE && resGetFSE.length">[{{resGetFSE.length}} feuille(s) de soins]</span>
            <span v-else>[Aucune feuille de soins trouvée]</span>
        </h1>
        <div class="component-button-choice-Lot">
            <button class="button-facture-lot onglet-actif">Factures du Poste de Travail</button>
        </div>
        <div class="container-selection-Lot">
            <h2>Sélection des factures PdT à afficher</h2>
            <div class="component-selection-Lot">

                <div class="container-checkBox-Lot">
                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox1" v-model="selectionToutesFse" @click="changement" />
                        Toutes
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbo2x" v-model="selectionSecuriseOuSsVitale" @click="changement" />
                        Sécurisé/Ss Vit
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox3" v-model="selectionNonSecuriseOuDegrades" @click="changement" />
                        Non Sec./Dégradé
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox4" v-model="selectionDesynchronisees" @click="changement" />
                        Désynchronisé
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox5" v-model="selectionNonSignees" @click="changement" />
                        Non signées
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox6" v-model="selectionSignees" @click="changement" />
                        Signées
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox7" v-model="selectionTransEnCours" @click="changement" />
                        Trans. en cours
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox8" v-model="selectionTraitees" @click="changement" />
                        Transmises/Traitées
                    </label>

                    <label for="myCheckbox">
                        <input type="checkbox" id="myCheckbox9" v-model="selectionRefusees" @click="changement" />
                        Refusée / A traiter
                    </label>

                </div>
                <div class="container-input-Lot">
                    <label>
                        Praticien :
                        <select v-model="pour_praticien" @change="changement">
                            <option :value="-1">(Tous)</option>
                            <option v-for="praticien in listePraticiens" :key="praticien.Idps" :value="praticien.Idps">{{ praticien.Nom }} {{ praticien.Prenom }} ({{ praticien.NoIdFac}})</option>
                        </select>
                    </label>
                    <label> Patient : <input type="text" placeholder="" v-model="nomPatient" @input="changement"></label>
                    <label> N° Sécu : <input type="text" placeholder="" v-model="numSecSoc"  @input="changement"></label>
                    <label> N° lot    <input type="text" placeholder="" v-model="numLot"     @input="changement"></label>
                    <label> N° fact : <input type="text" placeholder=""></label>
                    <label> Date      <input type="text" placeholder=""></label>

                </div>
            </div>
            <div class="ligne-recherche-etendue">
                <button type="button" class="btn-recherche-etendue" @click="toggleRechercheEtendue">
                    {{ afficherRechercheEtendue ? '▼' : '▶' }} Recherche étendue
                </button>
            </div>
            <div v-if="afficherRechercheEtendue" class="recherche-etendue">
                <div class="grille-recherche-etendue">
                    <label class="case-reservePS">
                        <input type="checkbox" v-model="avance.reservePS" @change="changement" />
                        Réservé PS
                    </label>
                    <label> NIR assuré <input type="text" v-model="avance.nirAssure" @input="changement" /></label>
                    <label> NIR bénéf. <input type="text" v-model="avance.nirBenef" @input="changement" /></label>
                    <label> Date naiss. bénéf. <input type="text" placeholder="JJ/MM/AAAA" v-date-fr v-model="avance.dateNaissanceBenef" @input="changement" /></label>
                    <label> Rang naiss. <input type="number" min="1" v-model.number="avance.rangNaissance" @input="changement" /></label>
                    <label> Régime <input type="text" v-model="avance.regime" @input="changement" /></label>
                    <label> Caisse <input type="text" v-model="avance.caisse" @input="changement" /></label>
                    <label> Centre <input type="text" v-model="avance.centre" @input="changement" /></label>
                    <label> Début soins <input type="text" placeholder="JJ/MM/AAAA" v-date-fr v-model="avance.debutSoins" @input="changement" /></label>
                    <label> Fin soins <input type="text" placeholder="JJ/MM/AAAA" v-date-fr v-model="avance.finSoins" @input="changement" /></label>
                    <label> Code presta. saisi <input type="text" v-model="avance.codePrestationSaisi" @input="changement" /></label>
                    <label> Code presta. transmis <input type="text" v-model="avance.codePrestationTransmis" @input="changement" /></label>
                </div>
                <div class="actions-recherche-etendue">
                    <button type="button" @click="reinitRechercheEtendue">Réinitialiser</button>
                </div>
            </div>
        </div>
        <div class="barre-actions-Lot">
            <button @click="toutSelectionner">Tout</button>
            <button @click="rienSelectionner">Rien</button>
            <button @click="selectionnerAuto">Sélection auto</button>
            <span class="separateur-actions"></span>
            <button @click="imprimerListe">Imprimer liste</button>
            <button :disabled="!selectionCodes.length" @click="bordereauIris">Bordereau IRIS</button>
            <button :disabled="!selectionCodes.length" @click="exportCSV">Export CSV</button>
            <button :disabled="!selectionCodes.length" @click="exportCSVReclamation">CSV réclamation</button>
            <button :disabled="!selectionCodes.length" @click="exportAG2035">Export Ag2035</button>
        </div>
        <div class="component-tab-Lot">
            <table>
                <thead>
                    <tr>
                        <th>Sél</th>
                        <th>Facture</th>
                        <th>N°Lot:</th>
                        <th>Praticien</th>
                        <th>Patient</th>
                        <th>N°sécu</th>
                        <th>Date FS</th>
                        <th>Mode / Etat</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="obj in resGetFSE" :key="obj.Code">
                        <tr :class="{ 'ligne-active': ligneActive && ligneActive.Code === obj.Code }"
                            @click="activerLigne(obj)">
                            <td @click.stop><input type="checkbox" :checked="estSelectionne(obj.Code)" @change="basculerSelection(obj.Code)" /></td>
                            <td>{{obj.Facture}}</td>
                            <td>{{obj.NoLot}}</td>
                            <td>{{obj.Praticien}}</td>
                            <td>{{obj.Patient}}</td>
                            <td>{{obj.NoSS}}</td>
                            <td>{{obj.DateFS}}</td>
                            <td>{{obj.ModeEtat}}</td>
                            <td @click.stop class="cellule-actions">
                                <!-- Actions CONTEXTUELLES : n'apparaissent que si pertinentes pour l'etat de la facture. -->
                                <button class="btn-ligne" @click="toggleDetails(obj)" title="Détail complet de la facture">Détails</button>
                                <button v-if="!obj.Signee && !obj.Annulee" class="btn-ligne btn-signer" @click="signerLigne(obj)" title="Signer (carte CPS)">Signer</button>
                                <button v-if="obj.Arl" class="btn-ligne" @click="arlLigne(obj)" title="Voir l'ARL">ARL</button>
                                <button v-if="obj.Arl" class="btn-ligne" @click="imprimerARLLigne(obj)" title="Imprimer l'ARL">Impr. ARL</button>
                                <button class="btn-ligne" @click="imprimerFSELigne(obj)" title="Imprimer la FSE">Impr. FSE</button>
                                <button class="btn-ligne" @click="ouvrirScor(obj)" title="Pièces jointes SCOR">PJ SCOR</button>
                                <button class="btn-ligne btn-suppr" @click="supprimerLigne(obj)" :title="obj.Annulee ? 'Restaurer' : 'Supprimer'">{{ obj.Annulee ? 'Restaurer' : 'Supprimer' }}</button>
                            </td>
                        </tr>
                        <tr v-if="detailsOuvert === obj.Code" class="ligne-actes">
                            <td colspan="9">
                                <div class="bloc-details">
                                    <div class="entete-details">
                                        <strong>Détail de la facture {{ obj.Code }}</strong>
                                        <span v-if="detailsChargement"> — chargement…</span>
                                    </div>
                                    <pre v-if="!detailsChargement" class="texte-details">{{ detailsTexte || 'Aucun détail.' }}</pre>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="component-button-Lot">
            <span class="compteur-selection">{{ selectionCodes.length }} sélectionnée(s)</span>
            <button class="close-button" :disabled="!selectionCodes.length" v-on:click="preparer">Préparer les Factures</button>
            <button class="close-button" :disabled="!selectionCodes.length" v-on:click="preparerEtTransmettre">Préparer et Transmettre</button>
            <button class="close-button" v-on:click="retour">Fermer</button>
        </div>

        <!-- Gestion des pieces jointes SCOR d'une FSE (port frmPJScor, ouvert depuis SignFSE). -->
        <DialogPiecesScor v-model:ouvert="scorOuvert" :noFse="scorNoFse" :identPatient="scorIdent" />
    </div>
</template>
<style scoped>
    .component-centered-Lot {
        margin-left: 5px;
        display: flex;
        flex-direction: column;
    }
    h1 {
        text-align: center;
    }
    .component-button-choice-Lot button {
        color: white;
        background: #004AAD;
        border: none;
        height: 30px;
        padding: 5px;
    }
    .component-button-choice-Lot button:hover {
        background: #CDE0ED;
        color: gray;
    }
    .container-selection-Lot {
        border: 1px solid grey;
        margin-bottom: 5px;
        margin-right: 5px;
    }
    h2 {
        color: darkblue;
        font-family: Arial;
        font-size: medium;
        margin: 10px;
        margin-bottom: 0px;
    }
    .component-selection-Lot {
        display: block;
        display: grid;
        grid-template-columns: 1fr 1fr;
        background-color: white;
        border: 1px solid grey;
        padding: 10px;
        margin: 10px;
    }
    .container-checkBox-Lot {
        font-family: Arial;
        color: black;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-row-gap: 10px;
    }
    .container-input-Lot {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .container-input-Lot label {
        flex-basis: 45%;
        margin-bottom: 10px;
    }
    .container-input-Lot input,
    .container-input-Lot select {
        width: 100%;
        padding: 5px;
    }
    .button-facture-lot {
        margin-right: 1px;
    }
    /* Recherche etendue (panneau replie) */
    .ligne-recherche-etendue {
        margin: 0 10px 8px;
    }
    .btn-recherche-etendue {
        background: none;
        border: none;
        color: darkblue;
        font-family: Arial;
        font-size: 14px;
        cursor: pointer;
        padding: 2px 0;
    }
    .btn-recherche-etendue:hover {
        text-decoration: underline;
    }
    .recherche-etendue {
        background: white;
        border: 1px solid grey;
        margin: 0 10px 10px;
        padding: 10px;
    }
    .grille-recherche-etendue {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 8px 12px;
    }
    .grille-recherche-etendue label {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        color: black;
    }
    .grille-recherche-etendue label.case-reservePS {
        flex-direction: row;
        align-items: center;
        gap: 6px;
    }
    .grille-recherche-etendue input[type="text"],
    .grille-recherche-etendue input[type="number"] {
        padding: 4px;
        width: 100%;
        box-sizing: border-box;
    }
    .actions-recherche-etendue {
        margin-top: 10px;
        text-align: right;
    }
    .actions-recherche-etendue button {
        background: #004AAD;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 6px 12px;
        cursor: pointer;
    }
    @media screen and (max-width: 800px) {
        .grille-recherche-etendue {
            grid-template-columns: 1fr 1fr;
        }
    }
    .component-button-choice-Lot .onglet-actif {
        background: lightgreen;
        color: #333;
    }
    /* Barre d'actions (Tout/Rien/Auto + actions mono/multi) */
    .barre-actions-Lot {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        align-items: center;
        margin: 5px 5px 0 0;
        padding: 5px;
        background: #f2f6fb;
        border: 1px solid grey;
    }
    .barre-actions-tla {
        background: #fbf5ec;
    }
    .barre-actions-Lot button {
        background: #004AAD;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 6px 10px;
        cursor: pointer;
        font-size: 13px;
    }
    .barre-actions-Lot button:hover:not(:disabled) {
        background: #2f6bc0;
    }
    .barre-actions-Lot button:disabled {
        background: #b9c4d4;
        cursor: not-allowed;
    }
    .separateur-actions {
        width: 1px;
        align-self: stretch;
        background: #b9c4d4;
        margin: 0 4px;
    }
    .compteur-selection {
        color: white;
        align-self: center;
        margin-right: 10px;
        font-size: 14px;
    }
    .close-button:disabled {
        background: #b9c4d4;
        cursor: not-allowed;
    }
    /* Actions par ligne (contextuelles) */
    .cellule-actions {
        white-space: nowrap;
    }
    .btn-ligne {
        border: 1px solid #b9c4d4;
        background: #eef3fa;
        color: #004AAD;
        border-radius: 4px;
        padding: 2px 6px;
        margin: 0 2px;
        font-size: 12px;
        cursor: pointer;
    }
    .btn-ligne:hover {
        background: #d9e6f5;
    }
    .btn-ligne.btn-signer {
        background: #e3f5e3;
        color: #1f7a1f;
        border-color: #9fd39f;
    }
    .btn-ligne.btn-suppr {
        background: #fdecec;
        color: #b32020;
        border-color: #e6a3a3;
    }
    .ligne-actes td {
        background: #f7f9fc;
    }
    .bloc-details {
        padding: 6px 10px;
    }
    .entete-details {
        color: #004AAD;
        margin-bottom: 4px;
    }
    .texte-details {
        margin: 0;
        padding: 8px 10px;
        background: white;
        border: 1px solid #d0d7e2;
        border-radius: 4px;
        color: #222;
        font-family: Consolas, 'Courier New', monospace;
        font-size: 12.5px;
        line-height: 1.35;
        white-space: pre-wrap;
        word-break: break-word;
        max-height: 320px;
        overflow: auto;
    }
    /* Ligne cliquee = cible des actions mono-ligne */
    .component-tab-Lot tr.ligne-active {
        background: #ffe9b3;
    }
    .component-tab-Lot tr.ligne-active:hover {
        background: #ffe09a;
    }
    .component-button-Lot {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px; /* Ajustez la marge supérieure selon vos besoins */
        position: fixed;
        bottom: 0px;
        right: 0px;
    }
    .close-button {
        margin: 15px;
        padding: 8px 16px;
        border: none;
        border-radius: 4px;
        background-color: #004AAD;
        color: white;
        font-size: 16px;
        font-weight: bold;
        text-transform: uppercase;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }
    .close-button:hover {
        background-color: lightblue;
    }
    .close-button:active {
        background-color: lightblue;
        outline: none; /* Pour enlever la bordure bleu */
    }
    .component-tab-Lot {
        background: white;
        height: 500px;
        margin-bottom: 500px;
        overflow-x: auto; /* le tableau defile horizontalement au lieu de deborder la page */
        -webkit-overflow-scrolling: touch;
    }
    .component-tab-Lot table {
        border-collapse: collapse;
        width: 100%;
    }
    .component-tab-Lot th, td {
        padding: 12px;
        text-align: left;
    }
    .component-tab-Lot th {
        /*background-color: #f2f2f2;*/
        background: #004AAD;
        color: #333;
        font-weight: bold;
        color: white;
    }
    .component-tab-Lot tr:hover {
        background: #CDE0ED;
    }
    /* Optionnel : Style pour la première ligne d'en-tête */
    .component-tab-Lot thead th {
        border-top: none;
    }

    /* Mobile : largeur mini pour garder le tableau lisible ; il defile dans son
       conteneur (.component-tab-Lot) au lieu d'etirer la page. */
    @media screen and (max-width: 800px) {
        .component-tab-Lot table {
            min-width: 700px;
        }
    }
</style>
<script>
        import { defineComponent } from 'vue';
        import GestionFSE from '../script/GestionFSE.js';
        import RequestManager from '../script/request.js';
        import { demanderPinSiRequis } from '@/script/pinCps';
        import DialogPiecesScor from './DialogPiecesScor.vue';

        export default defineComponent({
            components: { DialogPiecesScor },
            data: function () {
                return {
                    message: 'Bienvenu dans la page choix TransCam !',
                    numFse: "",
                    numLot: "",
                    numSecSoc: "",
                    nomPatient: "",
                    dateFse: "",
                    pour_praticien: -1,
                    fse_Tla: false,
                    modeRechercheLot: 1,
                    // Etats par defaut alignes sur l'appli d'origine (SignFSE.Initselect, mode PdT) :
                    // on masque les acceptees (Transmises/Traitees) et les Trans. en cours ; tout le
                    // reste est affiche, dont les Refusees / A traiter.
                    selectionToutesFse: false,
                    selectionSecuriseOuSsVitale: true,
                    selectionNonSecuriseOuDegrades: true,
                    selectionDesynchronisees: true,
                    selectionNonSignees: true,
                    selectionSignees: true,
                    selectionTransEnCours: false,
                    selectionTraitees: false,
                    selectionRefusees: true,
                    listePraticiens: [],
                    resGetFSE: [],
                    bSelectChange: true,
                    // Recherche etendue (porte de GestionFSE_Etendu) : panneau replie par defaut.
                    afficherRechercheEtendue: false,
                    avance: {
                        reservePS: false,
                        nirAssure: "",
                        nirBenef: "",
                        dateNaissanceBenef: "",
                        rangNaissance: 1,
                        regime: "",
                        caisse: "",
                        centre: "",
                        debutSoins: "",
                        finSoins: "",
                        codePrestationSaisi: "",
                        codePrestationTransmis: ""
                    },
                    // Selection : map code->true, pour un test d'appartenance O(1) sur les cases
                    // (evite le O(n^2) du v-model tableau quand "Tout" coche beaucoup de lignes).
                    selectionMap: {},
                    // Ligne cliquee (surbrillance).
                    ligneActive: null,
                    // Detail deplie sous une facture (code ouvert + texte formate via VisualiserActes).
                    detailsOuvert: null,
                    detailsTexte: "",
                    detailsChargement: false,
                    intervalId: null,
                    // Dialog pieces jointes SCOR (une FSE a la fois).
                    scorOuvert: false,
                    scorNoFse: 0,
                    scorIdent: 0
                }
            },
            computed: {
                // Options de selection envoyees au backend (forme optionsSelectionFseStr).
                optionsSelection() {
                    return {
                        numFse: this.numFse,
                        numLot: this.numLot,
                        numSecSoc: this.numSecSoc,
                        nomPatient: this.nomPatient,
                        dateFse: this.dateFse,
                        pour_praticien: this.pour_praticien,
                        fse_Tla: false,
                        modeRechercheLot: this.modeRechercheLot,
                        selectionToutesFse: this.selectionToutesFse,
                        selectionSecuriseOuSsVitale: this.selectionSecuriseOuSsVitale,
                        selectionNonSecuriseOuDegrades: this.selectionNonSecuriseOuDegrades,
                        selectionDesynchronisees: this.selectionDesynchronisees,
                        selectionNonSignees: this.selectionNonSignees,
                        selectionSignees: this.selectionSignees,
                        selectionTransEnCours: this.selectionTransEnCours,
                        selectionTraitees: this.selectionTraitees,
                        selectionRefusees: this.selectionRefusees,
                        // Criteres de recherche etendue (appliques cote backend en plus des filtres de base).
                        avance: this.avance
                    };
                },
                // Codes selectionnes (derives de la map) pour les payloads et compteurs.
                selectionCodes() {
                    return Object.keys(this.selectionMap);
                }
            },
            methods: {
                retour() {
                    history.back();
                },

                changement() {
                    this.bSelectChange = true;
                },

                // --- Recherche etendue ---
                toggleRechercheEtendue() {
                    this.afficherRechercheEtendue = !this.afficherRechercheEtendue;
                },
                reinitRechercheEtendue() {
                    this.avance = {
                        reservePS: false,
                        nirAssure: "",
                        nirBenef: "",
                        dateNaissanceBenef: "",
                        rangNaissance: 1,
                        regime: "",
                        caisse: "",
                        centre: "",
                        debutSoins: "",
                        finSoins: "",
                        codePrestationSaisi: "",
                        codePrestationTransmis: ""
                    };
                    this.bSelectChange = true;
                },

                // --- Selection (map O(1)) ---
                activerLigne(obj) {
                    this.ligneActive = obj;
                },
                estSelectionne(code) {
                    return !!this.selectionMap[code];
                },
                basculerSelection(code) {
                    if (this.selectionMap[code]) {
                        delete this.selectionMap[code];
                    } else {
                        this.selectionMap[code] = true;
                    }
                },
                toutSelectionner() {
                    // Coche UNIQUEMENT les factures affichees localement (aucun appel serveur).
                    const m = {};
                    for (const o of this.resGetFSE) { m[o.Code] = true; }
                    this.selectionMap = m;
                },
                rienSelectionner() {
                    this.selectionMap = {};
                },
                async selectionnerAuto() {
                    try {
                        const codes = await GestionFSE.selectionAuto(this.optionsSelection);
                        const m = {};
                        (codes || []).forEach(c => { m[String(c)] = true; });
                        this.selectionMap = m;
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },

                // --- Actions PAR LIGNE (contextuelles, sur l'objet de la ligne) ---
                // Signature : carte CPS sur le lecteur MAUI -> on delegue au pont MAUI (Kapelse).
                async signerLigne(obj) {
                    let pin;
                    try { pin = await demanderPinSiRequis(this.$store); }
                    catch (e) { return; } // PIN annule
                    GestionFSE.signerFSEViaMaui([obj.Code], pin);
                    this.bSelectChange = true; // rafraichissement au prochain poll
                },
                // Supprime / annule (non annulee) ou restaure / traite (annulee) : le backend detecte l'etat.
                async supprimerLigne(obj) {
                    const question = obj.Annulee
                        ? "Restaurer / traiter la facture " + obj.Code + " ?"
                        : "Supprimer / annuler la facture " + obj.Code + " ?";
                    if (!confirm(question)) return;
                    try {
                        const r = await GestionFSE.supprimer(obj.Code);
                        if (r && r.Message && !r.Success) alert(r.Message);
                        this.bSelectChange = true;
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },
                async arlLigne(obj) {
                    try {
                        const r = await GestionFSE.visualiserARL(obj.Code);
                        alert((r && r.Contenu) ? r.Contenu : "Aucun ARL pour cette facture.");
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },
                async imprimerARLLigne(obj) {
                    try { await GestionFSE.imprimerARL(obj.Code); }
                    catch (e) { alert(RequestManager.decrireErreur(e)); }
                },
                async imprimerFSELigne(obj) {
                    if (!confirm("Imprimer la feuille de soins " + obj.Code + " ?")) return;
                    try { await GestionFSE.imprimerFSE(obj.Code); }
                    catch (e) { alert(RequestManager.decrireErreur(e)); }
                },
                // Ouvre le dialog des pieces jointes SCOR pour la FSE (obj.Code = noFse = SDES_CODE ;
                // obj.Ident = SDES_NOPATIENT, pour la biblio d'ordonnances du patient).
                ouvrirScor(obj) {
                    this.scorNoFse = Number(obj.Code) || 0;
                    this.scorIdent = Number(obj.Ident) || 0;
                    this.scorOuvert = true;
                },
                // Deplie / replie le detail complet d'une facture (Strfse.VisualiserActes), a la demande.
                async toggleDetails(obj) {
                    if (this.detailsOuvert === obj.Code) {
                        this.detailsOuvert = null;
                        this.detailsTexte = "";
                        return;
                    }
                    this.detailsOuvert = obj.Code;
                    this.detailsTexte = "";
                    this.detailsChargement = true;
                    try {
                        const r = await GestionFSE.detailsFacture(obj.Code);
                        this.detailsTexte = (r && r.Contenu) ? r.Contenu : "";
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    } finally {
                        this.detailsChargement = false;
                    }
                },

                // --- Actions MULTI (sur la selection) ---
                // Prepare l'envoi (creation des lots cote backend). PIN porteur depuis le store.
                async preparer() {
                    if (!this.selectionCodes.length) return;
                    let codePin;
                    // Serie : PIN obligatoire au 1er lot (forcer) meme si la carte est ACTIVE.
                    try { codePin = await demanderPinSiRequis(this.$store, { forcer: true }); }
                    catch (e) { return; } // PIN annule ou carte absente
                    try {
                        const r = await GestionFSE.preparerEnvoi(this.selectionCodes, codePin);
                        if (r && r.Message) alert(r.Message);
                        this.bSelectChange = true;
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },
                async preparerEtTransmettre() {
                    if (!this.selectionCodes.length) return;
                    if (!confirm("Préparer et transmettre " + this.selectionCodes.length + " facture(s) ?")) return;
                    let codePin;
                    // Serie : PIN obligatoire au 1er lot (forcer) meme si la carte est ACTIVE.
                    try { codePin = await demanderPinSiRequis(this.$store, { forcer: true }); }
                    catch (e) { return; } // PIN annule ou carte absente
                    try {
                        const prep = await GestionFSE.preparerEnvoi(this.selectionCodes, codePin);
                        if (prep && prep.Success === false) {
                            alert(prep.Message || "Préparation échouée.");
                            return;
                        }
                        const r = await GestionFSE.transmettre(this.selectionCodes);
                        if (r && r.Message) alert(r.Message);
                        this.bSelectChange = true;
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },

                // Impression de la liste : cote navigateur (print du tableau).
                imprimerListe() {
                    window.print();
                },
                async bordereauIris() {
                    if (!this.selectionCodes.length) return;
                    try {
                        await GestionFSE.bordereauIris(this.selectionCodes);
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },
                async exportCSV() {
                    if (!this.selectionCodes.length) return;
                    try {
                        const r = await GestionFSE.exportCSV(this.selectionCodes);
                        if (r && typeof r.NbFactures === 'number') alert(r.NbFactures + " facture(s) exportée(s).");
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },
                async exportCSVReclamation() {
                    if (!this.selectionCodes.length) return;
                    try {
                        const r = await GestionFSE.exportCSVReclamation(this.selectionCodes);
                        if (r && typeof r.NbFactures === 'number') alert(r.NbFactures + " facture(s) exportée(s).");
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },
                async exportAG2035() {
                    if (!this.selectionCodes.length) return;
                    try {
                        const r = await GestionFSE.exportAG2035(this.selectionCodes);
                        if (r && r.Message) alert(r.Message);
                    } catch (e) {
                        alert(RequestManager.decrireErreur(e));
                    }
                },

                // Rafraichissement periodique de la grille (uniquement si un filtre a change).
                async sendCkFseStates() {
                    if (!this.bSelectChange) return;
                    this.bSelectChange = false;
                    try {
                        const response = await GestionFSE.chargerFSE(this.optionsSelection);
                        this.resGetFSE = response || [];
                        // Purge la selection / la ligne active / les actes des FSE disparues.
                        const codesPresents = new Set(this.resGetFSE.map(o => o.Code));
                        const m = {};
                        for (const c of this.selectionCodes) { if (codesPresents.has(c)) m[c] = true; }
                        this.selectionMap = m;
                        if (this.ligneActive && !codesPresents.has(this.ligneActive.Code)) {
                            this.ligneActive = null;
                        }
                        if (this.detailsOuvert && !codesPresents.has(this.detailsOuvert)) {
                            this.detailsOuvert = null;
                            this.detailsTexte = "";
                        }
                    } catch (error) {
                        console.error('Erreur lors du chargement des FSE :', error);
                    }
                }
            },
            props: {
                NoLot: {
                    type: String,
                }
            },
            async mounted() {
                try {
                    this.listePraticiens = await GestionFSE.chargerPraticiens() || [];
                } catch (e) {
                    console.error("Erreur chargement praticiens :", e);
                }

                if (this.$route.query.NoLot !== undefined) {
                    this.numLot = this.$route.query.NoLot;
                }

                this.intervalId = setInterval(this.sendCkFseStates, 1000);
            },
            beforeUnmount() {
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
            }
        });
</script>
